import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { useDaily } from 'common/state';
import { track } from 'common/analytics';
import { getTodayDate } from 'common/utils';

function DailyCard() {
  const [dailyState, dailyActions] = useDaily();
  const { language } = useParams();
  const { t } = useTranslation();

  useEffect(() => {
    dailyActions.load(language);
  }, [dailyActions, language]);

  return (
    <div className="daily-card">
      <div className="daily-card-title">{t('homeScreen.dailyGame')}</div>
      <div className="daily-card-date">{getTodayDate(language)}</div>
      <Link
        to={`/${language}/daily`}
        onClick={() => track.homeDailyGameButtonClick(language)}
      >
        <button type="button" className="button">
          {t('homeScreen.play')}
        </button>
      </Link>
    </div>
  );
}

export default DailyCard;
